import { useState } from 'react';
import { useHistory } from "react-router-dom";
import FormLogin from './form/Form.component';
import Login from './interfaces/Login';
import logo from "../../assets/logo/cencosudLogo.png";
import { BoxBody, BoxContainerLogin } from './Login.styles';
import { useSnackbar } from '../../context/Snackbar';
import { signIn } from '../../core/auth/auth';
import { authService } from './Login.service';
import { ResponseAuth } from './interfaces/Response';
import { AxiosResponse } from 'axios';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import { Authorization } from '../../authorization/Authorization';

export default function LoginComponent() {

  let history = useHistory();
  const [request, setRequest] = useState(false);
  const { snackbar, setSnackbar } = useSnackbar();

  const onSubmit = async (user: Login) => {
    setRequest(true);
    const response: AxiosResponse<ResponseAuth> = await authService(user);
    if (response.data.respuesta.cn) {
      signIn(response.data.respuesta);
      Authorization(response.data.respuesta.grupos).then((res) => {
        response.data.respuesta.access = res;
        signIn(response.data.respuesta);
        history.push("/");
      });
    } else {
      setSnackbar({ ...snackbar, msg: 'Falha na Autenticação!', type: 'error' });
    }
    setRequest(false);
  };

  return (
    <>
      <BoxBody>
        <BoxContainerLogin>
          <div className="logo"><img src={logo} alt="MinhaCenco" /><h1>MinhaCenco</h1></div>
          <div className="form">
            <FormLogin initialValues={INITIAL_VALUES} handleSubmitForm={onSubmit} request={request} />
          </div>
        </BoxContainerLogin>
      </BoxBody>
    </>
  );
}
